import z from 'zod';

export const promptSchema = z.object({
  system: z.string(),
  user: z.string(),
});

export interface Prompt extends z.infer<typeof promptSchema> {}
